<template>
  <section class="product-systems" aria-labelledby="product-systems-title">
    <div class="product-systems__inner">
      <h2 id="product-systems-title">Featured Products</h2>

      <div class="product-systems__layout">
        <router-link class="system-object system-object--octopus" to="/products/octopus">
          <figure>
            <img
              src="@/assets/images/octopus-product.png"
              alt="Octopus"
              loading="lazy"
              decoding="async"
            >
          </figure>
          <div class="system-object__copy">
            <h3>Octopus™</h3>
            <p>Control every angle.</p>
            <p class="system-object__technical-copy">Advanced pan-tilt-zoom monitoring for research and infrastructure applications.</p>
          </div>
        </router-link>

        <router-link class="system-object system-object--angler" to="/products/Angler">
          <figure>
            <img
              src="@/assets/images/angler-product.png"
              alt="Angler"
              loading="lazy"
              decoding="async"
            >
          </figure>
          <div class="system-object__copy">
            <h3>Angler™</h3>
            <p>Your always-on underwater window.</p>
            <p>Reliable fixed-view monitoring for long-term deployments.</p>
          </div>
        </router-link>

        <router-link class="system-object system-object--periscope" to="/products/periscope">
          <figure>
            <img
              src="@/assets/images/Periscope_app_mock_industrial_monitor 2.png"
              alt="Periscope AI"
              loading="lazy"
              decoding="async"
            >
          </figure>
          <div class="system-object__copy">
            <h3>Periscope AI™</h3>
            <p>Manage, monitor, record, and analyze underwater environments remotely.</p>
          </div>
        </router-link>
      </div>
    </div>

  </section>
</template>

<script>
export default { name: 'TechnicalSurface' }
</script>

<style lang="scss">
#app .product-systems {
  color: var(--ink);
  background: var(--sand);
}

#app .product-systems__inner {
  width: min(calc(100% - 80px), var(--page));
  margin: 0 auto;
  padding: clamp(94px, 7vw, 112px) 0 clamp(96px, 7.5vw, 118px);
}

#app .product-systems h2 {
  max-width: 10ch;
  margin-bottom: clamp(52px, 5vw, 72px);
  color: var(--ink);
  font-size: clamp(3.6rem, 6.4vw, 6.8rem);
  letter-spacing: -0.05em;
}

#app .product-systems__layout {
  display: grid;
  height: clamp(830px, 62vw, 900px);
  grid-template-columns: minmax(0, 1.38fr) minmax(390px, 0.96fr);
  grid-template-rows: minmax(0, 1.08fr) minmax(0, 0.92fr);
  column-gap: clamp(30px, 3vw, 48px);
  row-gap: 26px;
  align-items: stretch;
}

#app .system-object {
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-rows: minmax(0, 1fr) auto;
  color: var(--ink);
  text-decoration: none;
}

#app .system-object figure {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 0;
  height: auto;
  margin: 0;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background: #e8e4e5;
  isolation: isolate;
}

#app .system-object figure::after {
  position: absolute;
  right: 20%;
  bottom: 11%;
  left: 20%;
  height: 5%;
  border-radius: 50%;
  content: "";
  z-index: -1;
  background: rgba(7, 19, 35, 0.17);
  filter: blur(15px);
}

#app .system-object figure img {
  position: relative;
  z-index: 1;
  width: auto;
  height: auto;
  max-width: min(86%, 559px);
  max-height: 84%;
  object-fit: contain;
  filter: saturate(0.8) contrast(1.08) drop-shadow(0 22px 22px rgba(7, 19, 35, 0.16));
  transition: transform 420ms cubic-bezier(0.2, 0.7, 0.2, 1);
}

#app .system-object:hover figure img,
#app .system-object:focus-visible figure img {
  transform: translateY(-5px);
}

#app .system-object__copy {
  padding-top: 24px;
}

#app .system-object h3 {
  display: inline-flex;
  max-width: 100%;
  margin-bottom: 13px;
  align-items: flex-start;
  color: var(--ink);
  font-size: clamp(2.45rem, 3.3vw, 3.55rem);
  line-height: 0.96;
  white-space: nowrap;
}

#app .system-object h3::after {
  margin: 0.08em 0 0 0.32em;
  color: rgba(7, 19, 35, 0.48);
  content: "→";
  font-size: 0.36em;
  font-weight: 500;
  transition: transform 180ms ease, color 180ms ease;
}

#app .system-object:hover h3::after,
#app .system-object:focus-visible h3::after {
  color: var(--ink);
  transform: translateX(4px);
}

#app .system-object p {
  max-width: 500px;
  margin-bottom: 7px;
  color: var(--copy-dark);
  font-size: clamp(1.08rem, 1.25vw, 1.18rem);
  line-height: 1.55;
}

#app .system-object .system-object__technical-copy {
  max-width: 540px;
  margin-top: 17px;
  padding-top: 16px;
  border-top: 1px solid rgba(7, 19, 35, 0.16);
}

#app .system-object--octopus {
  grid-column: 1;
  grid-row: 1 / 3;
}

#app .system-object--octopus figure {
  background: #e3dfe0;
}

#app .system-object--octopus figure img {
  max-width: min(84%, 680px);
  max-height: 88%;
}

#app .system-object--octopus .system-object__copy {
  padding-top: 30px;
}

#app .system-object--octopus h3 {
  font-size: clamp(3.5rem, 4.6vw, 5rem);
}

#app .system-object--octopus p {
  font-size: clamp(1.12rem, 1.4vw, 1.22rem);
}

#app .system-object--angler {
  grid-column: 2;
  grid-row: 1;
  grid-template-columns: minmax(180px, 0.72fr) minmax(0, 1.1fr);
  grid-template-rows: 1fr;
  column-gap: 28px;
  align-items: center;
}

#app .system-object--angler figure {
  background: #ece8e9;
}

#app .system-object--angler figure img {
  max-width: 76%;
  max-height: 90%;
}

#app .system-object--angler .system-object__copy {
  padding-top: 0;
}

#app .system-object--periscope {
  grid-column: 2;
  grid-row: 2;
}

#app .system-object--periscope figure {
  background: #dddadd;
}

#app .system-object--periscope figure img {
  max-width: min(94%, 555px);
  max-height: 90%;
  filter: saturate(0.72) brightness(0.92) contrast(1.06) drop-shadow(0 24px 24px rgba(7, 19, 35, 0.14));
}

@media (max-width: 1100px) {
  #app .product-systems__inner {
    width: calc(100% - 60px);
  }

  #app .product-systems__layout {
    height: auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto;
    column-gap: 24px;
    row-gap: 52px;
  }

  #app .system-object--octopus {
    grid-column: 1 / -1;
    grid-row: auto;
    grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.85fr);
    grid-template-rows: 1fr;
    column-gap: 38px;
    align-items: end;
  }

  #app .system-object--octopus figure {
    height: 520px;
  }

  #app .system-object--octopus .system-object__copy {
    padding: 0 0 18px;
  }

  #app .system-object--angler,
  #app .system-object--periscope {
    grid-row: auto;
  }

  #app .system-object--angler {
    grid-column: 1;
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr) auto;
    column-gap: 0;
    align-items: stretch;
  }

  #app .system-object--angler .system-object__copy {
    padding-top: 24px;
  }

  #app .system-object--periscope { grid-column: 2; }

  #app .system-object--angler figure,
  #app .system-object--periscope figure {
    height: 310px;
  }
}

@media (max-width: 820px) {
  #app .product-systems__inner {
    width: calc(100% - 40px);
    padding: 88px 0 98px;
  }

  #app .product-systems h2 {
    margin-bottom: 58px;
    font-size: clamp(3.2rem, 14vw, 5rem);
  }

  #app .product-systems__layout {
    column-gap: 20px;
    row-gap: 48px;
  }

  #app .system-object--octopus {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    column-gap: 0;
  }

  #app .system-object--octopus figure {
    height: 440px;
  }

  #app .system-object--octopus .system-object__copy {
    padding: 28px 0 0;
  }

  #app .system-object--angler figure,
  #app .system-object--periscope figure {
    height: 310px;
  }

  #app .system-object h3 {
    font-size: clamp(2.3rem, 6vw, 3rem);
  }

  #app .system-object--octopus h3 {
    font-size: clamp(3.35rem, 9vw, 4.5rem);
  }

  #app .system-object p {
    font-size: 1.06rem;
  }
}

@media (max-width: 620px) {
  #app .product-systems__layout {
    grid-template-columns: 1fr;
    row-gap: 66px;
  }

  #app .system-object--octopus,
  #app .system-object--angler,
  #app .system-object--periscope {
    grid-column: 1;
  }

  #app .system-object figure,
  #app .system-object--octopus figure,
  #app .system-object--angler figure,
  #app .system-object--periscope figure {
    height: auto;
    aspect-ratio: 5 / 4;
  }

  #app .system-object--angler figure {
    aspect-ratio: 1 / 1;
  }

  #app .system-object--periscope figure {
    aspect-ratio: 4 / 3;
  }

  #app .system-object__copy,
  #app .system-object--octopus .system-object__copy {
    padding-top: 25px;
  }

  #app .system-object h3,
  #app .system-object--octopus h3 {
    font-size: clamp(2.85rem, 12.5vw, 3.7rem);
  }

  #app .system-object--octopus figure img { max-width: min(88%, 680px); }
  #app .system-object--angler figure img { max-width: 74%; max-height: 92%; }
  #app .system-object--periscope figure img { max-width: min(94%, 555px); }
}

@media (prefers-reduced-motion: reduce) {
  #app .system-object figure img,
  #app .system-object h3::after { transition: none; }
  #app .system-object:hover figure img,
  #app .system-object:focus-visible figure img { transform: none; }
  #app .system-object:hover h3::after,
  #app .system-object:focus-visible h3::after { transform: none; }
}
</style>
